import { render, staticRenderFns } from "./pageComparables.vue?vue&type=template&id=140700da&scoped=true&"
import script from "./pageComparables.vue?vue&type=script&lang=js&"
export * from "./pageComparables.vue?vue&type=script&lang=js&"
import style0 from "./pageComparables.vue?vue&type=style&index=0&id=140700da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140700da",
  null
  
)

export default component.exports